import { Input } from '@/components/Input';
import { RevealSlot } from '@/components/RevealSlot';
import {
    selectOtherIncome,
    selectPaidFrequency,
    setOtherIncome,
    setOtherIncomeSource,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';
import { getFrequencyLabel } from '@/utils/getFrequencyLabel';
import { getNumber } from '@/utils/valueFormat';

import { OtherIncomeSource } from '../OtherIncomeSource';

export interface IOtherIncome {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'OtherIncome';

export function OtherIncome({ baseId, showErrors }: IOtherIncome): JSX.Element {
    // ***** Redux *****
    const fields = useFieldCopy();
    const otherIncome = useAppSelector(selectOtherIncome);
    const paidFrequency = useAppSelector(selectPaidFrequency);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        // MAXIMUM
        const MAXIMUM = 99999;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === otherIncome) return;
        dispatch(setOtherIncome(intValue));
        if (intValue !== 0) return;
        dispatch(setOtherIncomeSource(undefined));
    }

    // ***** Render *****
    const frequencyLabel = getFrequencyLabel(paidFrequency);
    return (
        <>
            <div data-testid={testId}>
                <Input
                    title={
                        frequencyLabel
                            ? `${
                                  fields.otherIncome
                              } (${frequencyLabel.toLowerCase()})`
                            : fields.otherIncome
                    }
                    placeholder='380'
                    showErrors={false} // Not mandatory field
                    required={false}
                    onChange={handleChange}
                    id={`${baseId}-input-otherIncome`}
                    value={otherIncome?.toLocaleString()}
                    prefix='$'
                    showNumpad={true}
                    tooltipContent='Regular income from any other source, such as a second job, rent or government payments.'
                />
            </div>
            <RevealSlot open={otherIncome !== undefined && otherIncome > 0}>
                {/* The real flag, not false: an amount without a source
                    keeps Income incomplete, so hiding the error left Continue
                    doing nothing with no field marked. */}
                <OtherIncomeSource
                    baseId={baseId}
                    showErrors={showErrors}
                />
            </RevealSlot>
        </>
    );
}
